/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type AllPermissions_userGroupsUserServiceInfo$ref = any;
type ServiceCard_dashboardApps$ref = any;
type UserGroupRow_userGroupsUserServiceInfo$ref = any;
export type AppQueryVariables = {|
  decodedEmail: string,
  encodedEmail: string,
|};
export type AppQueryResponse = {|
  +userProfile: ?{|
    +id: string,
    +emailAddress: ?string,
    +status: ?string,
    +uuid: ?string,
    +firstName: ?string,
    +lastName: ?string,
    +title: ?string,
    +companyName: ?string,
    +auth0Id: ?string,
  |},
  +userGroupsUserServiceInfo: ?$ReadOnlyArray<?{|
    +groupName: ?string,
    +groupUuid: ?string,
    +groupDetails: ?{|
      +userGroupUuid: ?string,
      +services: ?{|
        +countries: ?$ReadOnlyArray<?{|
          +services: ?$ReadOnlyArray<?{|
            +serviceName: ?string,
            +serviceId: ?string,
            +serviceUuid: string,
          |}>
        |}>
      |},
    |},
    +$fragmentRefs: UserGroupRow_userGroupsUserServiceInfo$ref & AllPermissions_userGroupsUserServiceInfo$ref,
  |}>,
  +dashboardApps: ?$ReadOnlyArray<?{|
    +serviceName: ?string,
    +tenantUuid: ?string,
    +$fragmentRefs: ServiceCard_dashboardApps$ref,
  |}>,
  +userAllPermissions: ?$ReadOnlyArray<?{|
    +tenantUuid: ?string,
    +permissionName: ?string,
    +roleCode: ?string,
    +serviceName: ?string,
  |}>,
|};
export type AppQuery = {|
  variables: AppQueryVariables,
  response: AppQueryResponse,
|};
*/


/*
query AppQuery(
  $decodedEmail: String!
  $encodedEmail: String!
) {
  userProfile(userEmail: $decodedEmail) {
    id
    emailAddress
    status
    uuid
    firstName
    lastName
    title
    companyName
    auth0Id
  }
  userGroupsUserServiceInfo(email: $encodedEmail) {
    groupName
    groupUuid
    groupDetails {
      userGroupUuid
      services {
        countries {
          services {
            serviceName
            serviceId
            serviceUuid
          }
        }
      }
    }
    ...UserGroupRow_userGroupsUserServiceInfo
    ...AllPermissions_userGroupsUserServiceInfo
  }
  dashboardApps(email: $encodedEmail) {
    serviceName
    tenantUuid
    ...ServiceCard_dashboardApps
  }
  userAllPermissions(email: $decodedEmail) {
    tenantUuid
    permissionName
    roleCode
    serviceName
  }
}

fragment AllPermissions_userGroupsUserServiceInfo on UserGroupsUserServiceInfo {
  groupUuid
  groupDetails {
    services {
      countries {
        services {
          serviceName
          serviceId
        }
      }
    }
  }
}

fragment ServiceCard_dashboardApps on DashboardApps {
  key
  uuid
  name
  serviceName
  serviceUrl
  imageUrl
  tenantUuid
  serviceId
}

fragment UserGroupRow_userGroupsUserServiceInfo on UserGroupsUserServiceInfo {
  groupName
  groupDetails {
    subGroupNumber
    userGroupUuid
    numberOfUsers
    createdDate
    tenantUuid
    services {
      countries {
        services {
          serviceName
          serviceUrl
          serviceIcon
          serviceId
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "decodedEmail"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "encodedEmail"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "userEmail",
      "variableName": "decodedEmail"
    }
  ],
  "concreteType": "UserProfile",
  "kind": "LinkedField",
  "name": "userProfile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailAddress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "auth0Id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "email",
    "variableName": "encodedEmail"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupUuid",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userGroupUuid",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceUuid",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tenantUuid",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "email",
      "variableName": "decodedEmail"
    }
  ],
  "concreteType": "UserAllPermissions",
  "kind": "LinkedField",
  "name": "userAllPermissions",
  "plural": true,
  "selections": [
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "permissionName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "roleCode",
      "storageKey": null
    },
    (v7/*: any*/)
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceUrl",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AppQuery",
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "UserGroupsUserServiceInfo",
        "kind": "LinkedField",
        "name": "userGroupsUserServiceInfo",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserGroupsElement",
            "kind": "LinkedField",
            "name": "groupDetails",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CountryList",
                "kind": "LinkedField",
                "name": "services",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Country",
                    "kind": "LinkedField",
                    "name": "countries",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Service",
                        "kind": "LinkedField",
                        "name": "services",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserGroupRow_userGroupsUserServiceInfo"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AllPermissions_userGroupsUserServiceInfo"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "DashboardApps",
        "kind": "LinkedField",
        "name": "dashboardApps",
        "plural": true,
        "selections": [
          (v7/*: any*/),
          (v10/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ServiceCard_dashboardApps"
          }
        ],
        "storageKey": null
      },
      (v11/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AppQuery",
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "UserGroupsUserServiceInfo",
        "kind": "LinkedField",
        "name": "userGroupsUserServiceInfo",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserGroupsElement",
            "kind": "LinkedField",
            "name": "groupDetails",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CountryList",
                "kind": "LinkedField",
                "name": "services",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Country",
                    "kind": "LinkedField",
                    "name": "countries",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Service",
                        "kind": "LinkedField",
                        "name": "services",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "serviceIcon",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "subGroupNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "numberOfUsers",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdDate",
                "storageKey": null
              },
              (v10/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "DashboardApps",
        "kind": "LinkedField",
        "name": "dashboardApps",
        "plural": true,
        "selections": [
          (v7/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "imageUrl",
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      },
      (v11/*: any*/)
    ]
  },
  "params": {
    "cacheID": "70c61788c28a56acb2c0698918187ca9",
    "id": null,
    "metadata": {},
    "name": "AppQuery",
    "operationKind": "query",
    "text": "query AppQuery(\n  $decodedEmail: String!\n  $encodedEmail: String!\n) {\n  userProfile(userEmail: $decodedEmail) {\n    id\n    emailAddress\n    status\n    uuid\n    firstName\n    lastName\n    title\n    companyName\n    auth0Id\n  }\n  userGroupsUserServiceInfo(email: $encodedEmail) {\n    groupName\n    groupUuid\n    groupDetails {\n      userGroupUuid\n      services {\n        countries {\n          services {\n            serviceName\n            serviceId\n            serviceUuid\n          }\n        }\n      }\n    }\n    ...UserGroupRow_userGroupsUserServiceInfo\n    ...AllPermissions_userGroupsUserServiceInfo\n  }\n  dashboardApps(email: $encodedEmail) {\n    serviceName\n    tenantUuid\n    ...ServiceCard_dashboardApps\n  }\n  userAllPermissions(email: $decodedEmail) {\n    tenantUuid\n    permissionName\n    roleCode\n    serviceName\n  }\n}\n\nfragment AllPermissions_userGroupsUserServiceInfo on UserGroupsUserServiceInfo {\n  groupUuid\n  groupDetails {\n    services {\n      countries {\n        services {\n          serviceName\n          serviceId\n        }\n      }\n    }\n  }\n}\n\nfragment ServiceCard_dashboardApps on DashboardApps {\n  key\n  uuid\n  name\n  serviceName\n  serviceUrl\n  imageUrl\n  tenantUuid\n  serviceId\n}\n\nfragment UserGroupRow_userGroupsUserServiceInfo on UserGroupsUserServiceInfo {\n  groupName\n  groupDetails {\n    subGroupNumber\n    userGroupUuid\n    numberOfUsers\n    createdDate\n    tenantUuid\n    services {\n      countries {\n        services {\n          serviceName\n          serviceUrl\n          serviceIcon\n          serviceId\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4a158412dd9d5e5282137b2e1e94aa39';

module.exports = node;
